import type { SignalsApiStatusResponse } from "app/pages/sales-intelligence/sub-modules/management/types";
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";

export type SignalsApiIntegrationServiceApiType = {
    getStatus(): Promise<SignalsApiStatusResponse>;
    uploadDomainsList(body: FormData, mode: string): Promise<Response>;
    downloadUrl(): Promise<{ url: string }>;
};

export const createSignalsApiIntegrationService = (
    fetchService: IFetchService,
): SignalsApiIntegrationServiceApiType => ({
    getStatus: createCancelable((signal: AbortSignal): Promise<SignalsApiStatusResponse> => {
        return fetchService.get(`/sales-api/api-signals/status`, null, { cancellation: signal });
    }),
    uploadDomainsList: (body: FormData, mode: string = "append"): Promise<Response> => {
        return fetch(`/sales-api/api-signals/domains/upload?mode=${mode}`, {
            method: "POST",
            body,
            credentials: "include",
        });
    },
    downloadUrl: createCancelable((signal: AbortSignal): Promise<{ url: string }> => {
        return fetchService.get(`/sales-api/api-signals/domains/download-url`, null, { cancellation: signal });
    }),
});
